<template>
  <div>
    <!-- list -->
    <div class="p-6 pt-0">
      <div v-if="!isAddModalShow && !isEditModalShow">
        <vs-table
          id="katha-list"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="800px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="kathaFilteredCount"
          :max-items="length"
          :data="kathaRecords"
        >
          <template slot="header">
            <div class="mb-2 flex items-center flex-wrap justify-between w-full">
              <div class="flex items-center flex-wrap">
                <div class="mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (kathaFilteredCount && 1)) || 0 }}
                        -
                        {{ kathaFilteredCount - page * length > 0 ? page * length : kathaFilteredCount }}
                        of {{ kathaTotal || 0 }}
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
                <vs-button v-if="checkPermissionSlug(['gurudwara_katha_create'])" @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add {{ module_name }}
                </vs-button>
                <vs-button
                  v-if="checkPermissionSlug(['gurudwara_katha_delete']) && selectedRows.length"
                  @click="bulkDeleteRecords"
                  color="danger"
                  size="default"
                  style="padding: 12px 30px; margin-left: 10px"
                >
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /> Delete Selected
                </vs-button>
              </div>
              <div class="katha-date-filter">
                <flat-pickr v-model="dateRange" :config="datePickerConfig" placeholder="Select Date" class="w-full" id="dateRange" name="dateRange" />
                <feather-icon v-if="dateRange" icon="XIcon" svgClasses="h-5 w-5 text-danger" data-clear v-tooltip="'Clear'" @click="clearDateRange" />
              </div>
            </div>
          </template>

          <template slot="thead">
            <vs-th v-if="checkPermissionSlug(['gurudwara_katha_delete'])">
              <vs-checkbox :value="isAllSelected" :indeterminate="isSomeSelected" @change="toggleSelectAll" />
            </vs-th>
            <vs-th>Sr#</vs-th>
            <vs-th>Event Title</vs-th>
            <vs-th>User</vs-th>
            <vs-th>From Date</vs-th>
            <vs-th>To Time</vs-th>
            <vs-th v-if="checkPermissionSlug(['gurudwara_katha_edit', 'gurudwara_katha_delete', 'gurudwara_katha_view'])">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td class="flex justify-start" v-if="checkPermissionSlug(['gurudwara_katha_delete'])">
                <vs-checkbox :value="selectedRows.includes(tr._id)" @change="toggleRowSelection(tr._id)" />
              </vs-td>
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['gurudwara_katha_edit'])" @click.stop="toggleEditModal(tr._id)" v-tooltip="{ content: `Edit ${tr.event_title}` }">{{
                  tr.event_title || '-'
                }}</span>
                <span v-else>{{ tr.event_title || '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <span>{{ tr.user ? tr.user.first_name + ' ' + tr.user.last_name : '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <span>{{ tr.from_date ? formatLocal(tr.from_date, 'DD-MM-YYYY hh:mm A') : '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <span>{{ tr.to_date ? formatLocal(tr.to_date, 'DD-MM-YYYY hh:mm A') : '-' }}</span>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['gurudwara_katha_edit', 'gurudwara_katha_delete', 'gurudwara_katha_view'])">
                <div class="inline-flex">
                  <vx-tooltip
                    v-if="checkPermissionSlug(['gurudwara_katha_edit']) || checkPermissionSlug(['gurudwara_katha_view'])"
                    :text="`${module_name} Details ${checkPermissionSlug(['gurudwara_katha_edit']) ? 'Edit' : 'View'}`"
                  >
                    <feather-icon
                      @click.stop="toggleEditModal(tr._id)"
                      :icon="checkPermissionSlug(['gurudwara_katha_edit']) ? 'EditIcon' : 'EyeIcon'"
                      svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer"
                    />
                  </vx-tooltip>
                  <vx-tooltip v-if="checkPermissionSlug(['gurudwara_katha_delete'])" :text="`${module_name} Delete`">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="TrashIcon" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!-- Custom Pagination -->
        <vs-pagination v-if="kathaFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-8"></vs-pagination>
      </div>

      <!-- Add modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted" :showModal.sync="isAddModalShow" :action_name="'Add'" />

      <!-- Edit modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted" :showModal.sync="isEditModalShow" :selectedRecordId="selectedRecordId" :action_name="'Update'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import actionModal from './action'
import { dateMixins } from '@/mixins/dateMixins.js'
import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  name: 'KathaList',

  components: { actionModal, flatPickr },
  /** Data */
  data: () => ({
    selectedRows: [],
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: {
      title: '',
      type: 'Details'
    },

    dateRange: null,
    datePickerConfig: {
      wrap: true,
      mode: 'range', // Enables date range selection
      dateFormat: 'd-m-Y'
    },

    module_name: 'Katha Schedule',

    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,

    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecordId: null
  }),

  // Date Formate.
  mixins: [dateMixins],
  /** computed */
  computed: {
    ...mapState('gurudwara', ['kathaRecords', 'kathaTotal', 'kathaFilteredCount', 'kathaListLoading', 'createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.kathaFilteredCount / this.length)
    },
    /** Check if all checkboxes are selected */
    isAllSelected() {
      return this.selectedRows.length === this.kathaRecords.length && this.kathaRecords.length > 0
    },

    /** Check if some checkboxes are selected (for indeterminate state) */
    isSomeSelected() {
      return this.selectedRows.length > 0 && this.selectedRows.length < this.kathaRecords.length
    }
  },

  /** Functions */
  methods: {
    ...mapActions('gurudwara', {
      get: 'kathaGet',
      delete: 'kathaDelete',
      create: 'kathaCreate'
    }),

    /** Toggle Select All */
    toggleSelectAll() {
      if (this.selectedRows.length === this.kathaRecords.length) {
        this.selectedRows = []
      } else {
        this.selectedRows = this.kathaRecords.map((tr) => tr._id)
      }
    },

    /** Toggle Individual Row Selection */
    toggleRowSelection(id) {
      const index = this.selectedRows.indexOf(id)
      if (index === -1) {
        this.selectedRows.push(id)
      } else {
        this.selectedRows.splice(index, 1)
      }
    },

    /** Bulk Delete */
    bulkDeleteRecords() {
      if (this.selectedRows.length === 0) return

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Bulk Delete`,
        text: `Are you sure you want to delete ${this.selectedRows.length} records?`,
        accept: () => this.deleteMultipleRecords(),
        acceptText: 'Delete'
      })
    },

    /** Bulk Delete API Call */
    async deleteMultipleRecords() {
      try {
        const { message } = await this.$store.dispatch('gurudwara/kathaBulkDelete', { katha: this.selectedRows })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.selectedRows = []
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** Katha Popup */
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      let startDate = null
      let endDate = null
      if (this.dateRange) {
        const dateRangeArray = this.dateRange.split(' to ')

        // Adjust parsing to match the new format 'DD-MM-YYYY'
        startDate = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc() // Set to start of day in UTC
        endDate = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc() // Set to end of day in UTC
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc()
      }

      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        gurudwara: this.$route.params.id,
        start_date: startDate ? startDate.toISOString() : null, // Send as ISO string in UTC
        end_date: endDate ? endDate.toISOString() : null // Send as ISO string in UTC
      })
    },

    toggleEditModal(id) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = id
    },

    /** Delete Confirmation*/
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete  API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** create Katha Heading */
    async createKathaHeading() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        this.form.gurudwara = this.$route.params.id
        const { message } = await this.create(this.form)
        this.getData()
        this.form = {}
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    clearDateRange() {
      this.dateRange = null // Clear the dateRange value
      this.getData() // Optionally call your data fetch function to reset the data
    }
  },

  /** Watchers */
  watch: {
    dateRange() {
      this.page = 1 // Reset to the first page when date range changes
      this.getData()
    },
    kathaListLoading() {
      if (this.kathaListLoading) {
        this.$vs.loading({
          container: '#katha-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#katha-list > .con-vs-loading')
      }
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#invite-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-gurudwara > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    },
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
<style>
.katha-date-filter {
  position: relative;
  width: 240px;
}

.katha-date-filter .flatpickr-input,
.katha-date-filter input.flatpickr-input {
  width: 100%;
  height: 42px;
  padding: 8px 36px 8px 14px;
  font-size: 14px;
  line-height: 1.25;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-sizing: border-box;
}

.katha-date-filter .feather-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 2;
}
</style>
